import { DateTime } from 'luxon'
const $toUnixInteger = function (date = '') {
  return DateTime.fromISO(date).toUnixInteger()
}
let toUnixInteger = {
  install: (app, options) => {
    app.config.globalProperties.$toUnixInteger = $toUnixInteger
    app.provide('toUnixInteger', $toUnixInteger)
  }
}

export default toUnixInteger
